<template>
  <div>
    <!-- Navigation menu --->
    <AbNavigation
      :_back="true"
      :_save="true"
      :_next="true"
      @back="goback()"
      @save="create"
      @next="create"
      :editable="showNavbar"
      currentItem="Profile"
    ></AbNavigation>
    <div class="row">
      <div class="col-md-12 p-4">
        <div class="row px-4">
          <div class="col-md-12 mb-3 pr-0">
            <h2 v-if="isEdit">
              Edit
              {{
                $route.name.includes("Deploy")
                  ? "Deployment"
                  : testNameMap[Number(testType)]
              }}
              Profile
            </h2>
            <h2 v-else>
              New
              {{
                $route.name.includes("Deploy")
                  ? "Deployment"
                  : testNameMap[Number(testType)]
              }}
              Profile
            </h2>
          </div>
        </div>
        <div class="row px-4">
          <div class="col-md-12 col-xl-8 pr-4">
            <div class="form-group mb-4">
              <label v-translate class="font-weight-bold" for="inputUsername">Profile Name</label>
              <input
                type="text"
                class="form-control"
                id="inputUsername"
                placeholder="e.g. New pricing component testing"
                v-model="testName"
                style="max-width: 91.666667%;"
              />
              <span id="usernameHelp" class="form-text text-muted" v-translate>Give this {{ $route.name.includes("Deploy") ? "deployment" : "experiment" }} profile a name</span>
            </div>

            <div class="form-group mb-4" v-if="Number(testType) === 5">
              <label class="font-weight-bold" for="inputExperimentKey">{{ t('Experiment Key') }}</label>
              <input
                type="text"
                class="form-control"
                id="inputExperimentKey"
                placeholder="e.g. pricing-test-component"
                v-model="experimentKey"
                style="max-width: 91.666667%;"
              />
              <!-- <small id="usernameHelp" class="form-text text-muted" v-translate>Give this {{ $route.name.includes("Deploy") ? "deployment" : "experiment" }} profile a name</small> -->
            </div>            

            <div class="form-group mb-4" v-if="Number(testType) !== 5">
              <label
                class="font-weight-bold"
                for="inputCompany"
                v-if="[1, 3, 4].includes(Number(testType))"
                >{{
                  t("What is the editor URL page you would like to use?")
                }}</label>
              <label
                class="font-weight-bold"
                for="inputCompany"
                v-if="[0].includes(Number(testType))"
                >{{
                  t(
                    "Which webpage would you like to " +
                      ($route.name.includes("Deploy") ? "deploy" : "test") +
                      "?"
                  )
                }}</label
              >
              <label
                class="font-weight-bold"
                for="inputCompany"
                v-if="Number(testType) === 2"
                >{{ t("Base Variation URL") }}</label
              >

              <div class="form-group">
                <div class="form-row">
                  <div class="col-auto">
                    <select
                      v-model="protocol"
                      required
                      class="custom-select"
                      style="width: auto !important"
                    >
                      <option value="https://">https://</option>
                      <option value="http://">http://</option>
                    </select>
                  </div>
                  <div class="col">
                    <input
                      v-on:keyup.enter="inputCheck()"
                      v-on:keyup="entered = false"
                      v-on-clickaway="hideSuggestion"
                      type="text"
                      v-model="url"
                      class="form-control"
                      id="url"
                      @keyup="
                        checkURL();
                        if (!isEdit) {
                          updateVariants();
                        }
                        showSuggestion = true;
                      "
                      @click="showSuggestion = true"
                      :placeholder="'e.g. www.example.com/'"
                      autocomplete="off"
                      style="max-width: 90.95%;"
                    />
                    <div
                      class="auto-suggest-abtest"
                      v-if="
                        showSuggestion &&
                          !entered &&
                          urlSuggestionstions &&
                          urlSuggestionstions.length
                      "
                      :key="autosuggestIndex"
                    >
                      <div
                        class="suggestion"
                        v-for="item in urlSuggestionstions"
                        v-show="urlMatch(item.destination)"
                        v-bind:key="item.destination"
                        @click="
                          url = item.destination;
                          entered = true;
                          checkURL();
                          updateVariants();
                        "
                      >
                        <span style="font-weight: 500" class="mr-1">
                          {{ item.destination }}</span
                        >
                        <!-- <span class="text-muted">{{ item.domain }}</span> -->
                      </div>
                    </div>
                  </div>
                </div>

                <span
                  v-if="!invalidUrl && Number(testType) !== 2"
                  id="usernameHelp"
                  class="form-text text-muted"
                  >{{ t('Specify the URL you would like to generate previews and modify in the Visual Editor')}}</span
                >

                <span
                  class="form-text text-danger"
                  v-show="invalidUrl && url"
                  v-translate
                  >This is an invalid URL</span
                >
              </div>
            </div>
            <template v-if="Number(testType) === 2">
              <div :key="variantKey">
                <div
                  class="form-group mb-4"
                  v-for="(item, key) in variants"
                  :key="key"
                >
                  <label class="font-weight-bold" for="inputCompany">{{
                    item.name ? item.name : "Variant " + (key + 1).toString()
                  }}</label>

                  <div class="form-group">
                    <div class="form-row">
                      <div class="col-md-11">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon2">{{
                              protocol
                            }}</span>
                          </div>
                          <input
                            :disabled="item.disabled"
                            type="text"
                            v-model="item.url"
                            class="form-control"
                            id="url"
                            @keyup="
                              formatURL($event.target);
                              suburlStatus(key);
                            "
                            :placeholder="
                              'e.g. www.example.com/v' + (key + 1).toString()
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-1">
                        <!-- <span @click="removeVariant(key)">trash</span> -->
                        <font-awesome-icon
                          v-if="variants.length > 1"
                          @click="removeVariant(key)"
                          icon="trash"
                          class="text-danger fa-sm remove-button cursor-pointer"
                          style="margin-top: 20px"
                        />
                      </div>
                      <div class="d-flex justify-content-between w-100" style="max-width: 92%;">
                        <div>
                          <toggle-button
                            v-model="item.relay_param"
                            :value="item.relay_param"
                            :sync="true"
                            color="#2eb15a"
                            :labels="true"
                            class="mr-2 mt-2"
                          /> <span class="text-muted">Keep original URL query strings / hashes</span>
                        </div>

                        <span v-if="item.url && item.url.includes('*')" class="btn btn-dark fs-12 px-2 m-2 py-0" @click="previewLink(item.url)">Preview Link</span>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  @click="addVariants"
                  class="btn btn-third btn-outline-dashed btn-block"
                  style="width: 91.6%;"
                  >+ Add URL Variant</span
                >
                <br />
              </div>
            </template>
            <input v-model="testType" type="hidden" />

            <div class="form-group mb-4" v-if="!$route.name.includes('Deploy')">
              <label class="font-weight-bold">Hypothesis (Optional)</label>
              <select
                v-model="hypothesisId"
                @change="changeHypothesis()"
                class="custom-select"
                style=""
              >
                <option value="-1">No hypothesis</option>
                <option value="0">Add a new hypothesis</option>
                <option
                  v-for="(item, key) in hypothesisList"
                  v-bind:key="key"
                  :value="item.hypothesis_id"
                  :selected="item.hypothesis_id === hypothesisId"
                >
                  {{ item.observation }}
                </option>
              </select>
            </div>

            <div v-if="Number(hypothesisId) !== -1" v-bind:key="refresher">
              <div class="form-group mb-4">
                <label class="font-weight-bold">Observation</label>
                <input
                  type="text"
                  v-model="hypoObservation"
                  class="form-control"
                  placeholder="e.g. Low check out rate"
                  style=""
                />
              </div>

              <div class="form-group mb-4">
                <label class="font-weight-bold"
                  >What is the problem that you're trying to solve?</label
                >
                <textarea
                  v-model="hypoProblem"
                  placeholder="e.g. potential buyer are not complete the check out process"
                  class="form-control"
                  rows="3"
                  style=""
                ></textarea>
              </div>

              <div class="form-group mb-4">
                <label class="font-weight-bold"
                  >What is the solution to the problem?</label
                >
                <textarea
                  v-model="hypoSolution"
                  placeholder="e.g. reduce the required information that buyer need to fill in"
                  class="form-control"
                  rows="3"
                  style=""
                ></textarea>
              </div>
              <div class="form-group mb-4 row" style="align-items: center; ">
                <div class="col-md-6">
                  <span class="font-weight-bold">Confidence</span>
                  <p class="form-text text-muted">
                    Rate the potential of the hypothesis to achieve better
                    conversion.
                  </p>
                </div>
                <div class="col-md-6 mb-auto mt-3 px-0">
                  <div
                    id="howu-pre-answer"
                    style="display: flex; align-items: center;"
                  >
                    <div class="d-inline-block fs-14 mx-2 font-weight-bold">
                      {{ "Low" }}
                    </div>
                    <div class="d-inline-block w-75" style="text-align: center">
                      <template v-for="i in 5">
                        <button
                          v-bind:key="i"
                          :class="
                            `hypothesis-tag hypothesis-button-width ${
                              hypoConfidence === i
                                ? 'hypothesis-tag-selected'
                                : ''
                            }`
                          "
                          @click="changeButtonOption('confidence', i)"
                        >
                          {{ i }}
                        </button>
                      </template>
                    </div>
                    <div class="d-inline-block fs-14 mx-2 font-weight-bold">
                      {{ "High" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-4 row" style="align-items: center; ">
                <div class="col-md-6">
                  <span class="font-weight-bold">Importance</span>
                  <p class="form-text text-muted">
                    The valuable level of the visitor group landing on the
                    experiment pages.
                  </p>
                </div>
                <div class="col-md-6 mb-auto mt-3 px-0">
                  <div
                    id="howu-pre-answer"
                    style="display: flex; align-items: center;"
                  >
                    <div class="d-inline-block fs-14 mx-2 font-weight-bold">
                      {{ "Low" }}
                    </div>
                    <div class="d-inline-block w-75" style="text-align: center">
                      <template v-for="i in 5">
                        <button
                          v-bind:key="i"
                          :class="
                            `hypothesis-tag hypothesis-button-width ${
                              hypoImportance === i
                                ? 'hypothesis-tag-selected'
                                : ''
                            }`
                          "
                          @click="changeButtonOption('importance', i)"
                        >
                          {{ i }}
                        </button>
                      </template>
                    </div>
                    <div class="d-inline-block fs-14 mx-2 font-weight-bold">
                      {{ "High" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-4 row" style="align-items: center; ">
                <div class="col-md-6">
                  <span class="font-weight-bold">Difficulty</span>
                  <p class="form-text text-muted">
                    The difficulty level of implementing the changes in the
                    hypothesis.
                  </p>
                </div>
                <div class="col-md-6 mb-auto mt-3 px-0">
                  <div
                    id="howu-pre-answer"
                    style="display: flex; align-items: center;"
                  >
                    <div class="d-inline-block fs-14 mx-2 font-weight-bold">
                      {{ "Low" }}
                    </div>
                    <div class="d-inline-block w-75" style="text-align: center">
                      <template v-for="i in 5">
                        <button
                          v-bind:key="i"
                          :class="
                            `hypothesis-tag hypothesis-button-width ${
                              hypoDifficulty === i
                                ? 'hypothesis-tag-selected'
                                : ''
                            }`
                          "
                          @click="changeButtonOption('difficulty', i)"
                        >
                          {{ i }}
                        </button>
                      </template>
                    </div>
                    <div class="d-inline-block fs-14 mx-2 font-weight-bold">
                      {{ "High" }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group mb-4">
                <label class="font-weight-bold">Source URL</label>
                <input
                  type="text"
                  v-model="hypoURL"
                  placeholder="e.g. https://www.example.com (Optional)"
                  class="form-control"
                  style=""
                />
              </div>
            </div>
            <!-- <div class="form-group mb-4">
              <label
                class="font-weight-bold"
                for="traffic-allocation"
                >{{ t('How would you like to allocate traffic for this ' + ($route.name.includes('Deploy') ? 'deployment' : 'experiment') + '?') }}</label
              >
              <div class="form-group">
                <div class="form-row">
                  <div class="col">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroupPrepend">%</span>
                      </div>
                      <input
                        :disabled="isEdit"
                        v-model="trafficAllocation"
                        @keyup="checkTrafficAllocation()"
                        type="number"
                        class="form-control"
                        id="traffic-allocation"
                        min="1"
                        max="100"
                      />                      
                    </div>
                  </div>
                </div>
                <small id="usernameHelp" class="form-text text-muted" v-if="!invalidTrafficAllocation" v-translate>% of visitors will be exposed to it</small>
                <small class="form-text text-danger" v-else="invalidTrafficAllocation" v-translate>This is an invalid traffic allocation percentage</small>
              </div>
            </div> -->

            <!-- <div class="row">
              <div class="col-md-6">
                <button
                  class="btn btn-muted"
                  @click="goback()"
                >
                  Go Back
                </button>
              </div>                       
              <div class="col-md-6 text-right">
                <button
                  class="btn btn-first d-inline-block"
                  @click="create()"
                  v-if="Number(testType) === 1 || Number(testType) === 3 || Number(testType) === 4"
                  style="margin-right: 8.2%;"
                >
                  <span v-if="!isEdit">{{ t('Next: ' + ($route.name.includes('Deploy') ? 'Make Changes' : 'Create Variants')) }}</span>
                  <span v-else>{{ t('Save Changes') }}</span>
                </button>

                <button
                  class="btn btn-first d-inline-block"
                  @click="create()"
                  v-if="Number(testType) === 0"
                  style="margin-right: 8.2%;"
                >
                  <span v-if="!isEdit">{{ t('Next: Targeting') }}</span>
                  <span v-else>{{ t('Save Changes') }}</span>
                </button>


                <button
                  class="btn btn-first d-inline-block"
                  @click="create()"
                  v-if="Number(testType) === 2"
                  style="margin-right: 8.2%;"
                >
                  <span v-if="!isEdit">{{ t('Next: Targeting') }}</span>
                  <span v-else>{{ t('Save Changes') }}</span>
                </button>
              </div>
            </div> -->
          </div>
          <div
            class="d-md-none d-xl-block col-xl-4"
            style="display: flex; flex-direction: column;"
            v-if="!$route.name.includes('Deploy')"
          >
            <div style="padding: 20px">
              <!-- class="info-section"> -->
              <h6>
                <b v-translate>Set Goal, Test, Result</b>
              </h6>
              <img
                class="img-fluid mb-3"
                width="600"
                height="400"
                src="../assets/img/abtest-variant-2.jpg"
              />
              <p>
                {{
                  t(
                    "Simple change on headline, phrases, button, images, testimonials or any other element could bring more conversion."
                  )
                }}
              </p>
              <!-- <p>
              {{
                t(
                  'We will equally divide your website traffic among all the variations and track which one works best for you.'
                )
              }}
            </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "@/store";
import { mixin as clickaway } from "vue-clickaway";
import AbNavigation from "@/components/AbNavigation.vue";

export default {
  mixins: [clickaway],
  data: function() {
    return {
      // testNameMap: {
      //   0: "A/A Test",
      //   1: "A/B Test",
      //   2: "URL Split Test",
      //   3: "Personalization",
      //   4: "Multi Arm Bandit"
      // },
      testNameMap: {
        0: "A/A Test",
        1: "A/B Test",
        2: "URL Split Test",
        3: "Personalization",
        4: "A/B Test"
      },
      showNavbar: false,
      showAdvance: false,
      protocol: "https://",
      testName: null,
      experimentKey: null,
      testType: 1,
      url: null,
      rule: "simple",
      testId: 0,
      invalidUrl: false,
      intv: null,
      variants: [],
      variantKey: 0,
      isEdit: false,
      data: [],
      showSuggestion: false,
      suggestionLoaded: false,
      urlSuggestionstions: [],
      autosuggestIndex: 0,
      experimentTypeSelected: "",
      experimentTypes: [
        {
          heading: "A/B Test",
          text:
            "Test two or more different versions of a page. We'll handle hosting and serving them to your visitors.",
          isSelected: false,
          value: 1
        },
        {
          heading: "A/A Test",
          text:
            "Test two identical versions of a page to get conversion benchmark. We'll handle hosting and serving them to your visitors.",
          isSelected: false,
          value: 0
        },
        {
          heading: "Content Personalization",
          text:
            "Personalize content on your page for targeted visitors. We'll handle hosting and serving them to your visitors.",
          isSelected: false,
          value: 3
        },
        {
          heading: "Split URL / Redirect Test",
          text:
            "Test two or more variants by different URLs or paths. You make the pages in your system, you host them and we split the traffic.",
          isSelected: false,
          value: 2
        },
        {
          heading: "Multi Arm Bandit",
          text:
            "Test two or more versions and our algorithm will exploit and find the best variant for you. We'll handle hosting and serving them to your visitors.",
          isSelected: false,
          value: 4
        }
      ],
      trafficAllocation: 100,
      invalidTrafficAllocation: false,
      todayDate: "",
      excludedMAB: [], //20, 21, 22, 300, 301, 302
      auditLogDesc: [],
      oriTestInfo: [],
      currentVariantURL: [],
      removeItem: [],
      hypothesisId: -1,
      hypoObservation: "",
      hypoProblem: "",
      hypoSolution: "",
      hypoConfidence: 0,
      hypoImportance: 0,
      hypoDifficulty: 0,
      hypoURL: "",
      refresher: 0,
      hypothesisList: []
    };
  },
  store,
  computed: {
    filteredExperimentTypes() {
      if (!this.$isOptimize) {
        return this.experimentTypes.slice(0, -1);
      } else {
        return this.experimentTypes;
      }
    }
  },
  methods: {
    processRedirectPattern(url1, url2, oriUrl) {
      let [base1, query1] = url1.split('?');
      let [base2, query2] = url2.split('?');
    
      let base1Parts = base1.split('/');
      let base2Parts = base2.split('/');
    
      let j = -1; // pointer to the next part to get from url1
      let finalUrlArray = [];

      function containsOneAsterisk(str) {
        var firstIndex = str.indexOf('*');
        var lastIndex = str.lastIndexOf('*');
        return firstIndex === lastIndex && firstIndex !== -1;
      }

      function cancelOut(input, pattern) {
        if (!pattern) return ''
        let escapedPattern = pattern.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); 
        let regexPattern = new RegExp(escapedPattern.replace("\\*", "(.+)"));
        let matches = input.match(regexPattern);
        return matches && matches[1] ? matches[1] : ''
      }

      if (containsOneAsterisk(oriUrl)) {
        let dynamicValue = cancelOut(url1.replace('//www.','//'), oriUrl.replace('//www.','//'))
        return url2.replace('*', dynamicValue)
      }

      for (let i = 0; i < base2Parts.length; i++) {
        if (base2Parts[i].includes('*')) { // for cases like '*-2'
          j = base1Parts.indexOf(base2Parts[i-1]) !== -1 ? base1Parts.indexOf(base2Parts[i-1])+1 : base1Parts.length - 1; // look for the next element after '*'

          let diffKeyword = cancelOut(base1Parts[j], base2Parts[i]);
          finalUrlArray.push(base2Parts[i].replace('*', diffKeyword));

          base1Parts.splice(j, 1); // remove the captured part
        } else {
          finalUrlArray.push(base2Parts[i]); // unchanged part from url2
        }
      }
    
      if (base2Parts.includes('*') && j !== -1) {
        let remainingParts = base1Parts.slice(j);
        finalUrlArray.push(...remainingParts);
      }
    
      let finalUrl = finalUrlArray.join('/');
      let queryDiff = ''
      if (query1 && query2) queryDiff = cancelOut(query1, query2)
      if (query2) finalUrl += '?' + query2.replace('*', queryDiff);
      return finalUrl;
    },
    previewLink(url) {
      if (url.includes('*')) {
        this.$swal
        .fire({
          title: 'What URL do you want to preview?',
          text: `We will generate the final destination URL on the given pattern`,
          input: 'text',
          inputValue: this.url.replace(/\*/g, 'REPLACE-TEXT'),
          inputPlaceholder: this.url.replace(/\*/g, 'REPLACE-TEXT'),
          showCancelButton: true,
          confirmButtonColor: `rgb(${this.$MainColor})`
        })
        .then((result) => {
          if (result.value) {
            let finalURL = this.processRedirectPattern(result.value, url, this.url)

            this.$swal.fire({
              title: 'The final URL will be...',
              text: finalURL,
              type: 'success',
            })

            this.$swal.fire({
              title: 'The final URL will be...',
              text: this.protocol + finalURL,
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: `rgb(${this.$MainColor})`,
              cancelButtonColor: "#dedede",
              confirmButtonText: "Open a new tab"
            }).then((result) => {
              console.log(result)
              if (result.value) {
                window.open(this.protocol + finalURL, "_blank");
              }
            });
          }
        })            
      }
    },       
    changeHypothesis() {
      this.hypothesisId = Number(this.hypothesisId);
      if (this.hypothesisId === -1 || this.hypothesisId === 0) {
        this.hypoObservation = "";
        this.hypoProblem = "";
        this.hypoSolution = "";
        this.hypoConfidence = 0;
        this.hypoImportance = 0;
        this.hypoDifficulty = 0;
        this.hypoURL = "";
      } else {
        for (let i in this.hypothesisList) {
          if (this.hypothesisId === this.hypothesisList[i].hypothesis_id) {
            this.setHypothesisItem(this.hypothesisList[i]);
            break;
          }
        }
      }
      this.refresher++;
    },
    setHypothesisItem(item) {
      this.hypothesisId = item.hypothesis_id;
      this.hypoObservation = item.observation;
      this.hypoProblem = item.problem;
      this.hypoSolution = item.solution;
      this.hypoConfidence = item.confidence;
      this.hypoImportance = item.importance;
      this.hypoDifficulty = item.difficulty;
      this.hypoURL = item.hypothesis_url;
    },
    changeButtonOption(field, newVal) {
      switch (field) {
        case "confidence":
          this.hypoConfidence = newVal;
          break;
        case "importance":
          this.hypoImportance = newVal;
          break;
        case "difficulty":
          this.hypoDifficulty = newVal;
          break;
      }
    },
    selectOption(option) {
      if (
        option.value === 3 &&
        this.$session.get("paid_plan") === 20 &&
        !this.isEdit
      ) {
        this.upgradePop();
      } else if (
        option.value === 4 &&
        this.excludedMAB.includes(this.$session.get("paid_plan")) &&
        !this.isEdit
      ) {
        this.upgradePop();
      } else {
        if (!this.isEdit) {
          if (this.experimentTypeSelected)
            this.experimentTypeSelected.isSelected = false;
          this.experimentTypeSelected = option;
          this.testType = option.value;
          this.triggerTestType();
        }
      }
      // if (!this.isEdit) {
      //   if (this.experimentTypeSelected)
      //     this.experimentTypeSelected.isSelected = false
      //   this.experimentTypeSelected = option
      //   this.testType = option.value
      //   this.triggerTestType()
      // }
    },
    triggerTestType() {
      if (Number(this.testType) === 1) {
        this.variants = [];
      }
      if (Number(this.testType) === 2) {
        this.variants = [
          {
            name: null,
            url: this.url,
            touched: false,
            relay_param: false
          }
        ];
      }
      this.variantKey++;
    },
    addVariants(url = null, relay_param = false, disabled = false) {
      if (!url || typeof url !== "string") url = this.url;

      // Check if the user is on the free plan and already has one variant
      if (!this.isInitialLoading && this.$session.get("paid_plan") === 300 && this.variants.length >= 1) {
        this.$swal.fire({
          title: "Upgrade Required",
          text: "Free users are limited to 1 variant. Please upgrade your plan to add more variants.",
          type: "warning",
          confirmButtonColor: "#2167f5"
        });
        return;
      }

      this.variants.push({
        name: null,
        url: url,
        touched: false,
        disabled: disabled,
        relay_param: relay_param
      });
      this.variantKey++;
    },
    removeVariant(key) {
      let temp;
      temp = this.variants.splice(key, 1);
      this.removeItem.push(temp[0].url);
      this.variantKey++;
      if (this.isEdit) {
        for (let i = 0; i < this.removeItem.length; i++) {
          this.auditLogDesc.push({
            Delete: "variant " + this.removeItem[i]
          });
        }
      }
    },
    updateVariants() {
      let text = this.url.replace(/.*\/\//, "");
      for (let i in this.variants) {
        if (this.isEdit || this.variants[i].disabled) continue;
        if (!this.variants[i].touched) this.variants[i].url = text;
      }
    },
    suburlStatus(key) {
      this.variants[key].touched = true;
      if (this.variants[key].url === "") this.variants[key].touched = false;
    },
    goback() {
      this.$router.go(-1);
    },
    isURL(s) {
      var res = s.match(
        /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
      );
      return res !== null;
    },
    checkTrafficAllocation() {
      console.log(this.trafficAllocation);
      this.invalidTrafficAllocation = false;
      if (this.trafficAllocation < 0 || this.trafficAllocation > 100)
        this.invalidTrafficAllocation = true;
    },
    formatURL(el) {
      let url = el.value;
      if (url.startsWith("https://")) {
        url = url.replace(/^https\:\/\//, "");
      }
      if (url.startsWith("http://")) {
        url = url.replace(/^http\:\/\//, "");
      }
      el.value = url;
    },
    checkURL() {
      this.invalidUrl = false;
      clearInterval(this.intv);

      if(!this.url || this.url.trim() === '') {
        this.invalidUrl = true;
        return;
      }
      
      if (this.url.startsWith("https://")) {
        this.url = this.url.replace(/^https\:\/\//, "");
        this.protocol = "https://";
      }
      if (this.url.startsWith("http://")) {
        this.url = this.url.replace(/^http\:\/\//, "");
        this.protocol = "http://";
      }

      if (this.url.includes('*') && Number(this.testType) !== 2) {
        this.invalidUrl = true;
        return;
      }

      if (!this.isURL(this.protocol + this.url) && (!this.url.includes('*') || (this.url.includes('*') && Number(this.testType) !== 2))) {
        this.intv = setTimeout(() => {
          this.invalidUrl = true;
        }, 500);
      }

      if (this.url.startsWith("localhost")) {
        this.invalidUrl = false;
        clearInterval(this.intv);
      }
    },
    create(nav) {
      this.checkURL();

      if (Number(this.testType)=== 5) {
        this.url = 'backend.mida.so'
      } else if (!this.isURL(this.protocol + this.url) || this.url === "" || this.invalidUrl) {
        this.$swal.fire({
          title: "Error",
          text: "Page URL does not seems like a valid URL",
          type: "warning",
          confirmButtonColor: "rgb(255, 75, 57)"
        });
        this.invalidUrl = true;
        return;
      }

      if (this.isEdit && this.oriTestInfo.url !== this.protocol + this.url) {
        this.auditLogDesc.push({
          Create: "Experiment URL " + this.url
        });
      } else if (!this.isEdit) {
        this.auditLogDesc.push({
          Create: "Experiment URL " + this.url
        });
      }

      if (this.isEdit && this.testName && this.oriTestInfo.test_name !== this.testName) {
        this.auditLogDesc.push({
          Change: "Experiment name to " + this.testName
        });
      } else if (!this.isEdit && this.testName) {
        this.auditLogDesc.push({
          Change: "Experiment name to " + this.testName
        });
      }

      if (this.isEdit && this.experimentKey && this.oriTestInfo.experiment_key !== this.experimentKey) {
        this.auditLogDesc.push({
          Change: "Experiment name to " + this.experimentKey
        });
      } else if (!this.isEdit && this.experimentKey) {
        this.auditLogDesc.push({
          Change: "Experiment name to " + this.experimentKey
        });
      }      

      this.checkTrafficAllocation();
      if (this.invalidTrafficAllocation) {
        this.$swal.fire({
          title: "Error",
          text: "Traffic allocation does not seems like a valid percentage",
          type: "warning",
          confirmButtonColor: "rgb(255, 75, 57)"
        });
        this.invalidTrafficAllocation = true;
        return;
      }

      let data = {
        url: this.protocol + this.url,
        widget_id: this.$session.get("widget_id"),
        test_name: this.testName,
        experiment_key: this.experimentKey || null,
        is_split_test: 0,
        traffic_allocation: this.trafficAllocation
      };

      if (Number(this.testType) === 2 && !this.variants.length) {
        this.$swal.fire({
          title: "Error",
          text:
            "You will need at least one URL to perform a split URL testing!",
          type: "warning",
          confirmButtonColor: "rgb(255, 75, 57)"
        });
        return;
      }

      if (Number(this.testType) === 2 && this.variants.length) {
        for (let i = 0; i < this.variants.length; i++) {
          if (!this.variants[i].url || this.variants[i].url === "") continue;
          let url = this.variants[i].url.replace(/https?\:\/\//, "");

          if (this.protocol + url.replace(/^http(s)?\:\/\//, '') === this.protocol + this.url) {
            this.$swal.fire({
              title: "Error",
              text: "Variant URL must not be the same as Base URL!",
              type: "warning",
              confirmButtonColor: "rgb(255, 75, 57)"
            });
            return;            
          }
        }
      }      

      // Split URL Testing
      if (Number(this.testType) === 2) {
        if (this.isEdit && this.oriTestInfo.testType !== this.testType) {
          this.auditLogDesc.push({
            Change: "Experiment type to Split URL Test"
          });
        } else if (!this.isEdit) {
          this.auditLogDesc.push({
            Change: "Experiment type to Split URL Test"
          });
        }
        data.data = {};
        let obj = [];

        this.url
        for (let i = 0; i < this.variants.length; i++) {
          let urlurl = this.variants[i].url.replace(/https?\/\//, "");
          let namename = "Variant " + (i + 1).toString();

          if (this.url === urlurl) {
            this.$swal.fire({
              title: "Error",
              text: namename + " URL cannot be the same as Base Variation URL!",
              type: "warning",
              confirmButtonColor: "rgb(255, 75, 57)"
            });
            return;
          }
        }
        
        for (let i = 0; i < this.variants.length; i++) {
          if (!this.variants[i].url || this.variants[i].url === "") continue;
          let name = "Variant " + (i + 1).toString();
          if (this.variants[i].name) name = this.variants[i].name;
          let url = this.variants[i].url.replace(/https?\:\/\//, "");
          if (
            this.isEdit &&
            this.currentVariantURL[i] !== this.protocol + url
          ) {
            this.auditLogDesc.push({
              Change: "variant " + (i + 1) + " url to " + url
            });
          } else if (!this.isEdit) {
            this.auditLogDesc.push({
              Change: "variant " + (i + 1) + " url to " + url
            });
          }
          obj.push({
            name: name,
            nickname: name,
            data: [
              {
                url: this.protocol + url.replace(/^http(s)?\:\/\//, ''),
                relay_param: this.variants[i].relay_param
              }
            ]
          });
        }
        data.data[this.protocol + this.url] = obj;
        data.data = JSON.stringify(data.data);
        data.is_split_test = 1;
      }

      // A/A Testing
      if (Number(this.testType) === 0) {
        data.is_aa = 1;
        data.data = {};
        // {"https://howuku.com/":[{"name":"Variant 1","nickname":"Variant 1","data":[],"condition":{}}]}
        let obj = [];
        obj.push({
          name: "Variant 1",
          nickname: "Variant 1",
          data: [],
          customJS: "",
          customCSS: "",
          condition: {}
        });
        data.data[this.protocol + this.url] = obj;
        data.data = JSON.stringify(data.data);
        if (this.isEdit && this.oriTestInfo.testType !== this.testType) {
          this.auditLogDesc.push({
            Change: "experiment type to AA Test"
          });
        } else if (!this.isEdit) {
          this.auditLogDesc.push({
            Change: "experiment type to AA Test"
          });
        }
      }

      // Personalization
      if (Number(this.testType) === 3) {
        data.personalize = 1;
        if (this.isEdit && this.oriTestInfo.testType !== this.testType) {
          this.auditLogDesc.push({
            Change: "experiment type to Personalization Test"
          });
        } else if (!this.isEdit) {
          this.auditLogDesc.push({
            Change: "experiment type to Personalization Test"
          });
        }
      }

      // MAB Testing
      if (Number(this.testType) === 4) {
        if (this.isEdit && this.oriTestInfo.testType !== this.testType) {
          this.auditLogDesc.push({
            Change: "experiment type to Multi Armed Bandit Test"
          });
        } else if (!this.isEdit) {
          this.auditLogDesc.push({
            Change: "experiment type to Multi Armed Bandit Test"
          });
        }
        data.is_mab = 1;
      }

      if (Number(this.testType) === 1) {
        if (this.isEdit && this.oriTestInfo.testType !== this.testType) {
          this.auditLogDesc.push({
            Change: "experiment type to AB Test"
          });
        } else if (!this.isEdit) {
          this.auditLogDesc.push({
            Change: "experiment type to AB Test"
          });
        }
      }

      if (this.$route.name.includes("Deploy")) {
        this.testType = 3;
        data.personalize = 1;
        data.deploy = 1;
      }

      if (
        this.url !== "" &&
        this.testName &&
        (Number(this.hypothesisId) === -1 ||
          (Number(this.hypothesisId) !== -1 &&
            this.hypoObservation &&
            this.hypoProblem &&
            this.hypoSolution &&
            this.hypoConfidence &&
            this.hypoImportance &&
            this.hypoDifficulty))
      ) {
        if (!this.hypoURL.startsWith("http")) {
          this.hypoURL = "https://" + this.hypoURL;
        }

        // Create new test
        if (!this.isEdit) {
          this.$http
            .post(process.env.API_ENDPOINT + "/abtest/add", data)
            .then(response => {
              this.testId = response.data.test_id;
              // this.auditLogDesc = JSON.stringify(this.auditLogDesc)
              // this.$auditlog({ module: 'abtest', action: 'create test profile', action_id: this.testId, description: this.auditLogDesc})
              // this.auditLogDesc = []
              if (this.hypothesisId !== -1) {
                this.$http
                  .post(
                    process.env.API_ENDPOINT + "/abtest/hypothesis/update",
                    {
                      hypothesis_id: Number(this.hypothesisId),
                      observation: this.hypoObservation,
                      problem: this.hypoProblem,
                      solution: this.hypoSolution,
                      confidence: Number(this.hypoConfidence) || 0,
                      importance: Number(this.hypoImportance) || 0,
                      difficulty: Number(this.hypoDifficulty) || 0,
                      hypothesis_url: this.hypoURL,
                      widget_id: this.$session.get("widget_id"),
                      test_id: this.testId
                    }
                  )
                  .then(response1 => {
                    this.auditLogDesc.push({
                      Change: "hypothesis id to " + response1.data.hypothesis_id
                    });
                    this.auditLogDesc = JSON.stringify(this.auditLogDesc);
                    this.$auditlog({
                      module: "abtest",
                      action: "create test profile",
                      action_id: this.testId,
                      description: this.auditLogDesc
                    });
                    this.auditLogDesc = [];
                    // if (Number(this.testType) === 2 || Number(this.testType) === 0) {
                    //   this.$router.push({ path: '/experiment/targeting/' + this.testId });
                    // }
                    // else {
                    //   this.$router.push({ path: `/${this.$route.name.includes('Deploy') ? 'deploy' : 'experiment'}/targeting/${this.testId}` });
                    // }

                    this.$awn.success("Saved Profile", {
                      position: "bottom-right",
                      maxNotifications: 1
                    });
                    if (nav.redirect) {
                      this.$router.push({
                        path: nav.redirect.replace("ID_NOT_FOUND", this.testId)
                      });
                    }
                  });
              } else {
                this.$http
                  .post(
                    process.env.API_ENDPOINT + "/abtest/hypothesis/change",
                    {
                      hypothesis_id: 0,
                      widget_id: this.$session.get("widget_id"),
                      test_id: this.$route.params.test_id
                    }
                  )
                  .then(response1 => {
                    this.auditLogDesc = JSON.stringify(this.auditLogDesc);
                    this.$auditlog({
                      module: "abtest",
                      action: "create test profile",
                      action_id: this.testId,
                      description: this.auditLogDesc
                    });
                    this.auditLogDesc = [];
                    // if (Number(this.testType) === 2 || Number(this.testType) === 0) {
                    //   this.$router.push({
                    //     path: '/experiment/targeting/' + this.testId,
                    //   });
                    // }
                    // else {
                    //   this.$router.push({ path: `/${this.$route.name.includes('Deploy') ? 'deploy' : 'experiment'}/targeting/${this.testId}` });
                    // }

                    this.$awn.success("Saved Profile", {
                      position: "bottom-right",
                      maxNotifications: 1
                    });
                    if (nav.redirect) {
                      this.$router.push({
                        path: nav.redirect.replace(
                          "ID_NOT_FOUND",
                          this.testId
                        )
                      });
                    }
                  });
              }
            });
        } else if (this.isEdit && this.$route.params.test_id) { // edit test
          data.test_id = this.$route.params.test_id;
          // if (this.auditLogDesc.length) {
          //   this.auditLogDesc = JSON.stringify(this.auditLogDesc)
          //   this.$auditlog({ module: 'abtest', action: 'create test profile', action_id: this.$route.params.test_id, description: this.auditLogDesc})
          //   this.auditLogDesc = []
          // }
          this.$http
            .post(process.env.API_ENDPOINT + "/abtest/edit", data)
            .then(response => {
              if (Number(this.hypothesisId) !== -1) {
                this.$http
                  .post(
                    process.env.API_ENDPOINT + "/abtest/hypothesis/update",
                    {
                      hypothesis_id: Number(this.hypothesisId),
                      observation: this.hypoObservation,
                      problem: this.hypoProblem,
                      solution: this.hypoSolution,
                      confidence: Number(this.hypoConfidence) || 0,
                      importance: Number(this.hypoImportance) || 0,
                      difficulty: Number(this.hypoDifficulty) || 0,
                      hypothesis_url: this.hypoURL,
                      widget_id: this.$session.get("widget_id"),
                      test_id: this.$route.params.test_id
                    }
                  )
                  .then(response1 => {
                    this.auditLogDesc.push({
                      Change: "hypothesis id to " + response1.data.hypothesis_id
                    });
                    if (this.auditLogDesc.length) {
                      this.auditLogDesc = JSON.stringify(this.auditLogDesc);
                      this.$auditlog({
                        module: "abtest",
                        action: "create test profile",
                        action_id: this.$route.params.test_id,
                        description: this.auditLogDesc
                      });
                      this.auditLogDesc = [];
                    }
                    this.$awn.success("Saved Profile", {
                      position: "bottom-right",
                      maxNotifications: 1
                    });
                    if (nav.redirect) {
                      this.$router.push({ path: nav.redirect });
                    }
                  });
              } else {
                // change to no hypothesis
                this.$http
                  .post(
                    process.env.API_ENDPOINT + "/abtest/hypothesis/change",
                    {
                      hypothesis_id: 0,
                      widget_id: this.$session.get("widget_id"),
                      test_id: this.$route.params.test_id
                    }
                  )
                  .then(response1 => {
                    this.auditLogDesc.push({
                      Change: "remove hypothesis"
                    });
                    if (this.auditLogDesc.length) {
                      this.auditLogDesc = JSON.stringify(this.auditLogDesc);
                      this.$auditlog({
                        module: "abtest",
                        action: "create test profile",
                        action_id: this.$route.params.test_id,
                        description: this.auditLogDesc
                      });
                      this.auditLogDesc = [];
                    }
                    this.$awn.success("Saved Profile", {
                      position: "bottom-right",
                      maxNotifications: 1
                    });
                    if (nav.redirect) {
                      this.$router.push({ path: nav.redirect });
                    }
                  });
              }
            });
        }
      } else {
        this.$swal.fire({
          title: "Error",
          text: "Please fill up the information!",
          type: "warning",
          confirmButtonColor: "rgb(255, 75, 57)"
        });
        this.auditLogDesc = [];
      }
    },
    inputCheck() {
      setTimeout(() => {
        this.entered = true;
        this.autosuggestIndex++;
      }, 100);
    },
    hideSuggestion() {
      this.showSuggestion = false;
    },
    urlMatch(data) {
      if (this.url === null) return data;
      if (this.url !== null) return data.includes(this.url);
    },
    triggerSuggestions() {
      this.showSuggestion = true;
    },
    upgradePop() {
      let descriptionText;
      let titleText;
      let catogoryFirst = [20, 21, 22];
      let catogorySecond = [300, 301, 302];
      if (catogoryFirst.includes(this.$session.get("paid_plan"))) {
        titleText = "Upgrade Account";
        descriptionText =
          "Your current plan not support this feature, update your plan to use this feature.";
      } else if (catogorySecond.includes(this.$session.get("paid_plan"))) {
        titleText = "Upgrade To Growth Plan";
        descriptionText =
          "You need to upgrade your account to Growth plan to use this feature.";
      }
      this.$swal.fire({
        title: titleText,
        text: descriptionText,
        type: "warning",
        confirmButtonColor: "#2167f5"
      });
      return;
    },
    checkAATesting(x) {
      try {
        let obj = JSON.parse(x);
        return JSON.stringify(Object.values(obj)[0][0].data) === "[]";
      } catch (e) {
        return false;
      }
    }
  },
  created() {
    if (window.location.href.includes("/edit/")) this.isEdit = true;
  },
  activated() {
    if (this.$route.query.type) {
      this.testType = this.$route.query.type;
      this.selectOption({ value: this.$route.query.type });
    } else {
      this.testType = 3;
    }
  },
  mounted() {
    this.isInitialLoading = true
    if (this.$route.query.type) {
      this.testType = this.$route.query.type;
      this.selectOption({ value: this.$route.query.type });
    } else {
      this.testType = 3;
    }
    if (this.isEdit) {
      if (!this.$route.params.test_id) {
        if (this.$route.name.includes("Deploy"))
          this.$router.push({ path: "/deploy" });
        else this.$router.push({ path: "/experiment" });
      }
      this.$http
        .get(process.env.API_ENDPOINT + "/abtest/" + this.$route.params.test_id)
        .then(response => {
          if (response.data.length) {
            let data = response.data[0];
            this.oriTestInfo = data;
            this.oriTestInfo.testType = data.is_server ? 5 :
              data.is_aa ? 0
              : !data.is_ab ? 3
              : data.is_split_test ? 2
              : 1;
            this.showNavbar = [1, 0].includes(Number(this.oriTestInfo.status))
            this.testName = data.test_name;
            this.experimentKey = data.experiment_key || null;
            this.testType = data.is_server ? 5 :
              data.is_aa ? 0
              : !data.is_ab ? 3
              : data.is_split_test ? 2
              : 1;
            if (data.url.startsWith("https")) this.protocol = "https://";
            else this.protocol = "http://";
            this.url = data.url.replace("https://", "").replace("http://", "");
            this.trafficAllocation = data.traffic_allocation;
            if (data.hypothesis_id) {
              this.hypothesisId = data.hypothesis_id;
              this.changeHypothesis();
            }
            try {
              let splitTestUrl = [];
              let websiteTests = JSON.parse(data.data);
              Object.keys(websiteTests).forEach(function(key) {
                // let websiteName = key;
                let variantArr = websiteTests[key];
                // console.log(websiteName, variantArr)
                for (let t = 0; t < variantArr.length; t++) {
                  // we only need to check the first
                  // because Split URL only have 1 record
                  if (variantArr[t].data.length) {
                    let firstData = variantArr[t].data[0];
                    if (firstData && firstData.url) {
                      splitTestUrl.push({ url: firstData.url, relay_param: firstData.relay_param || false });
                    }
                  }
                }
              });
              for (let i = 0; i < splitTestUrl.length; i++) {
                let splitUrlVal = splitTestUrl[i].url.replace("https://", "").replace("http://", "")
                this.addVariants(splitUrlVal, splitTestUrl[i].relay_param, true);
              }
              console.log(this.variants)
              this.currentVariantURL = splitTestUrl;
            } catch (err) {
              console.error(err);
            }
            JSON.parse(data.data);
          } else {
            this.$router.push({ path: "/experiment" });
          }
          this.isInitialLoading = false
        });
    }
    this.$http
      .get(process.env.API_ENDPOINT + "/abtest/hypothesis")
      .then(response1 => {
        this.hypothesisList = response1.data;
        if (Number(this.hypothesisId) && Number(this.hypothesisId) !== -1) {
          this.changeHypothesis();
        }
        let option = {
          // heatmap_profile_id: window.atob(this.$route.params.heatmap_profile_id),
          widget_id: this.$session.get("widget_id")
        };
        this.suggestionLoaded = false;
        this.$http
          .get(process.env.API_ENDPOINT + "/auto-suggestion/url", option)
          .then(response => {
            this.urlSuggestionstions = response.data;
            let max = 0;
            this.urlSuggestionstions.map(x => {
              if (max === 0) max = x.count;
              x.percentage = x.count / max;
            });
            this.suggestionLoaded = true;
          });
        if (this.testType === 1) {
          let currentTypes = this.experimentTypes.find(
            item => item.value === 1
          );
          this.selectOption(currentTypes);
        }
      });
  },
  components: { AbNavigation }
};
</script>
<style>
.auto-suggest-abtest {
  background: #fff;
  overflow: auto;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 10%), 0 2px 3px rgb(0 0 0 / 15%);
  margin-top: 4px;

  position: absolute;
  max-height: 300px;
  z-index: 9999;
  top: 42px;
  left: 7px;
  width: calc(110.7vh - 26px);
}
.auto-suggest-abtest > .suggestion {
  padding: 12px;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  cursor: pointer;
}

.auto-suggest-abtest > .suggestion:hover {
  background-color: #f7f7f7;
}
.description-box {
  background-color: #eef2fb;
  padding: 0px 40px;
  padding-bottom: 10px;
  border-radius: 3px;
  margin-bottom: 36px;
}
.highlight {
  background-color: #f8f79fd0;
  font-weight: bold;
}

.red-highlight {
  background-color: #f89f9fd0;
  color: rgb(133, 36, 36);
}
.experiment-type-option {
  /*border: 1px solid black;*/
  border: 1px solid rgb(228, 232, 235);
  box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
  border-radius: 10px;
  padding: 20px;
  height: auto;
  font-size: 110%;
}
.experiment-type-option:hover {
  cursor: pointer;
}

.small-font {
  font-size: 12px;
}

.hypothesis-tag {
  border-radius: 3px;
  padding: 8px 0;
  font-size: 16px;
  background-color: #a2a9b7;
  border: none;
  color: #ffffff;
  margin: 3px 0;
  cursor: pointer;
  font-weight: 500;
  width: 100%;
  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
    0 1px 3px rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.howu-demo-nps-btn {
  width: 40.06px;
}

.hypothesis-button-width {
  width: calc(100% / 6);
  padding: 6px 0;
  margin: 0px 1.75px;
  font-size: 14px;
  font-weight: 400;
}

.hypothesis-tag-selected {
  background-color: #2b313c;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateTestProfile.vue